var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1282 0.6158C15.6332 0.120098 14.8293 0.12041 14.3336 0.6158L6.25659 8.69313L2.6667 5.10328C2.171 4.60757 1.36748 4.60757 0.871777 5.10328C0.376074 5.59898 0.376074 6.4025 0.871777 6.8982L5.35894 11.3854C5.60664 11.6331 5.93143 11.7572 6.25625 11.7572C6.58107 11.7572 6.90617 11.6334 7.15387 11.3854L16.1282 2.4107C16.6239 1.91534 16.6239 1.11147 16.1282 0.6158Z",
    fill: "#328734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green_tick.d4858b340519f452943bf970fd8bd5da.svg";
export { ForwardRef as ReactComponent };